// extracted by mini-css-extract-plugin
module.exports = {"primary":"#4073fa"};